import React from "react";
import CategoryCart from "./CategoryCart";
import { MdLaptop } from "react-icons/md";
import { AiOutlineDesktop, AiOutlineMobile } from "react-icons/ai";
import { BsSmartwatch, BsWatch } from "react-icons/bs";
const category = [
  {
    url: "/products/Mobile",
    title: "Mobile",
    icon: <AiOutlineMobile />,
  },
  {
    url: "/products/SmartWatch",

    title: "Smart Watch",
    icon: <BsWatch />,
  },
  {
    url: "/products/Monitor",
    title: "Monitor",
    icon: <AiOutlineDesktop />,
  },
  {
    url: "/products/Laptop",
    title: "Laptop",
    icon: <MdLaptop />,
  },
];

const FeatureCategory = () => {
  return (
    <div className=" ">
      <h1 className="text-xl md:text-2xl font-bold text-center py-3 text-slate-700">
        Feature Category
      </h1>
      <div className="flex flex-row flex-wrap items-center justify-center">
        {category.map((cat) => (
          <CategoryCart
            key={cat.title}
            name={cat.title}
            icon={cat.icon}
            url={cat.url}
          />
        ))}
      </div>
    </div>
  );
};

export default FeatureCategory;
